// --- Personal Projects ---
import boidsThumb from "../images/boids-thumb.jpg";
import boidsBg from "../images/boids-bg.jpg";
import boids1 from "../images/boids-1.jpg";
import boids2 from "../images/boids-2.jpg";
import boids3 from "../images/boids-3.jpg";

import metalThumb from "../images/metal-thumb.png";
import metalBg from "../images/metal-bg.png";
import metal1 from "../images/metal-1.png";
import metal2 from "../images/metal-2.png";

// --- Game Jams ---
import jansJamThumb from "../images/jans-jam-thumb.png";
import jansJamBg from "../images/jans-jam-bg.png";
import jansJam1 from "../images/jans-jam-1.png";
import jansJam2 from "../images/jans-jam-2.png";

import monkeyThumb from "../images/falling-monkey-thumb.png";
import monkeyBg from "../images/falling-monkey-bg-new.png";
import monkey1 from "../images/falling-monkey-1.png";
import monkey2 from "../images/falling-monkey-2.png";
import monkey3 from "../images/falling-monkey-3.png";

import beanThumb from "../images/bean-thumb.png";
import beanBg from "../images/bean-bg.png";
import bean1 from "../images/bean-1.jpg";
import bean2 from "../images/bean-2.jpg";
import bean3 from "../images/bean-3.jpg";

import bossThumb from "../images/bosscade-thumb.png";
import bossBg from "../images/bosscade-bg.png";
import boss1 from "../images/bosscade-1.png";
import boss2 from "../images/bosscade-2.png";
import boss3 from "../images/bosscade-3.png";
import boss4 from "../images/bosscade-4.png";

export const gamesData = {
    personalProjects: [
        {
            id: "boids",
            title: "Oh Boids!",
            thumbnail: boidsThumb,
            backgroundImage: boidsBg,
            screenshots: [boids1, boids2, boids3],
            tags: ["Programming", "2D Art"],
            description: "A customizable boids simulation where hundreds of fish exhibit emergent flocking behaviour. Built from scratch to explore how simple per-agent rules create complex, organic group movement.",
            link: "https://nickvg.itch.io/oh-boids",
            embedSrc: "https://itch.io/embed/2244129",
            bgColor: "adb9b1",
            fgColor: "222222",
            linkColor: "fa5c5c"
        },
        {
            id: "metal",
            title: "Show Your Metal",
            thumbnail: metalThumb,
            backgroundImage: metalBg,
            screenshots: [metal1, metal2],
            tags: ["Programming", "Sound Design", "Puzzle Design"],
            description: "A co-op puzzle game made with Bart Hagoort. Guide a little metal man through a Portal-inspired testing facility, solving physics-based puzzles together.",
            link: "https://lokitheshady.itch.io/show-your-metal",
            embedSrc: "https://itch.io/embed/1443875",
            bgColor: "d1e0db",
            fgColor: "222222",
            linkColor: "e38b00"
        },
        {
            id: "jam",
            title: "Jans Jam",
            thumbnail: jansJamThumb,
            backgroundImage: jansJamBg,
            screenshots: [jansJam1, jansJam2],
            tags: ["Programming", "2D Art", "Sound Design", "Music"],
            description: "A short but sweet game about catching as much jam as possible. All visuals, sound effects, and music were made from scratch by me.",
            link: "https://nickvg.itch.io/jans-jam",
            embedSrc: "https://itch.io/embed/2004414",
            bgColor: "C42F2F",
            fgColor: "222222",
            linkColor: "fa5c5c"
        }
    ],
    gameJams: [
        {
            id: "monkey",
            title: "Falling Monkey",
            thumbnail: monkeyThumb,
            backgroundImage: monkeyBg,
            screenshots: [monkey1, monkey2, monkeyBg, monkey3],
            tags: ["Programming", "2D Art", "Sound Design"],
            description: "A monkey who is done with life, but life is not done with him. A melancholic platformer that deepened my respect for sound design. Every *boing* had to feel just right.",
            link: "https://nickvg.itch.io/falling-monkey",
            embedSrc: "https://itch.io/embed/1676599",
            bgColor: "ffecd6",
            fgColor: "0d2b45",
            linkColor: "ffaa5e"
        },
        {
            id: "bean",
            title: "Blow That Bean Off The Table!",
            thumbnail: beanThumb,
            backgroundImage: beanBg,
            screenshots: [bean1, bean2, bean3],
            tags: ["Programming", "3D Modeling", "Sound Design", "Writing"],
            description: "Inspired by The Stanley Parable and found footage like The Backrooms. A gloomy, atmospheric horror experience built around an unassuming vegetable, exploring how mood, sound, and simple narrative can unsettle.",
            link: "https://nickvg.itch.io/blow-that-bean-off-the-table",
            embedSrc: "https://itch.io/embed/2132730",
            bgColor: "1b1c16",
            fgColor: "2cff2a",
            linkColor: "327345"
        },
        {
            id: "boss",
            title: "BossCade",
            thumbnail: bossThumb,
            backgroundImage: bossBg,
            screenshots: [boss1, boss2, boss3, boss4],
            tags: ["Programming", "2D Art", "Design", "Game Feel"],
            description: "A fast-paced retro arcade boss fight with procedural gameplay that evolves as you improve. The chaos ramps up the better you play, keeping every run fresh and intense.",
            link: "https://nickvg.itch.io/bosscade",
            embedSrc: "https://itch.io/embed/2514038",
            bgColor: "111111",
            fgColor: "8fd1ff",
            linkColor: "7d2953"
        }
    ],
    seriousGames: [
        {
            id: "eyeTracking",
            title: "Virtual reality eye-tracking escape room",
            thumbnail: jansJamThumb,
            backgroundImage: jansJamBg,
            tags: ["VR", "Eye-Tracking", "Research", "Escape Room"],
            description: "This escape room was made in collaboration with the lectorate at Fontys to research the possibilities of eye-tracking in virtual reality games.",
            link: "https://www.youtube.com/watch?v=hnQDXada8EA&ab_channel=nickvangerwen",
            className: "EyeTracking"
        },
        {
            id: "waterYouDoing",
            title: "Water You Doing?",
            thumbnail: jansJamThumb,
            backgroundImage: jansJamBg,
            tags: ["Educational", "Water", "Mini-games", "Futurebites"],
            description: "'Water You Doing?' was made for the 'Night of the Nerds', an event by Futurebites showcasing creativity, innovation and technology.",
            link: "https://youtu.be/aNN6NGJJU9I",
            className: "WaterYouDoing"
        }
    ]
};
